import DeleteClinicalConcern from './DeleteClinicalConcern';

export default DeleteClinicalConcern;
